import { render, staticRenderFns } from "./ResendInvitationNew.vue?vue&type=template&id=473091b6&scoped=true"
import script from "./ResendInvitationNew.vue?vue&type=script&lang=ts"
export * from "./ResendInvitationNew.vue?vue&type=script&lang=ts"
import style0 from "./ResendInvitationNew.vue?vue&type=style&index=0&id=473091b6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473091b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('473091b6')) {
      api.createRecord('473091b6', component.options)
    } else {
      api.reload('473091b6', component.options)
    }
    module.hot.accept("./ResendInvitationNew.vue?vue&type=template&id=473091b6&scoped=true", function () {
      api.rerender('473091b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/invite/ResendInvitationNew.vue"
export default component.exports